<template>
  <validation-provider ref="validator" :name="id" mode="eager" v-slot="{ errors, classes }" slim>
    <div :class="{...rowCSSClass, ...classes}">
      <label :for="id" :class="{...labelCSSClass}">{{ inputLabel }} <small v-if="required">*</small></label>
      <div :class="{...fieldCSSClass}">
        <Checkbox 
            :id="id"
            :class="{...inputCSSClass, 'p-default':true, 'p-pulse':true, 'required':required, 'form-control':false, ...classes}"
            color="success-o" 
            name="matricule" 
            :checked="input"
            v-on:change="(val) => { input = val }">
        </Checkbox> 
        <span :class="{...controlCSSClass}" v-if="errors.length > 0">{{ errors[0] }}</span>
      </div>
    </div>
  </validation-provider>
</template>

<script lang="ts">
import { Component, Watch, Prop } from '@fwk-node-modules/vue-property-decorator';
import { mixins } from '@fwk-node-modules/vue-class-component';
import GenericInput from '../../mixins/GenericInput.vue';
import Checkbox from './pretty-checkbox/Checkbox.vue';

@Component({
  components : {
    Checkbox
  }
})
export default class CheckboxRow extends mixins<GenericInput<boolean>>(GenericInput) {

  input:any = this.value !== undefined ? this.value : false;

  get inputLabel() {
    return (this.label && this.label != "") ? this.label : "";
  }

  validate() {
    // @ts-ignore
    return this.$refs.validator.validate();
  }

  @Watch('value')
  onValueChange(val: any, oldVal: any) {
    this.input = val;
    // @ts-ignore
    this.$refs.validator.validate(val);
  }
  
}
</script>